import styled from '@emotion/styled'

import { Button, spacing } from 'main/ui'

import { FieldGroupContainer } from '../../common'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const GroupContainer = styled.div`
  display: flex;
  flex-direction: column;

  > * {
    flex-basis: 0;
    flex-grow: 1;
  }

  > :not(:last-child) {
    margin-bottom: ${spacing.majorScale(2)}px;
  }
`

export const TextualContainer = styled.div`
  margin-top: ${spacing.majorScale(3)}px;
`
export const SmallTextContainer = styled(TextualContainer)`
  margin-top: ${spacing.majorScale(2)}px;
`
export const RightTextContainer = styled(TextualContainer)`
  text-align: right;
`
export const BlockContainer = styled.div`
  margin-top: ${spacing.majorScale(4)}px;
`

export const UserFieldContainer = styled.div`
  margin-top: ${spacing.majorScale(1)}px;
`
export const DirectorFieldGroupContainer = styled(FieldGroupContainer)`
  margin-top: ${spacing.majorScale(2)}px;
`
export const StyledButton = styled(Button)`
  margin-top: ${spacing.majorScale(3)}px;
`
